module.exports = __webpack_public_path__ + "img/empty-img.aaf68876.png";